import React, { useEffect, useState } from "react";

const sponsors = [
  { id: 1, name: "PRD RIGS" },
  { id: 2, name: "KANINI" },
  { id: 3, name: "ROADMAP IT SOLUTIONS" },
];

const SponsorsSection: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="py-20 px-4">
      <div className="container max-w-6xl mx-auto">
        
        {/* Section Header */}
        <div
          className={`text-center mb-14 transition-all duration-700 ${
            isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-2 h-2 bg-primary glow-blue" />
            <span className="text-primary font-display text-sm tracking-[0.3em] uppercase">
              Sponsors
            </span>
          </div>

          <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground">
            POWERED BY{" "}
            <span className="text-primary text-glow-blue">INNOVATORS</span>
          </h2>

          <div className="neon-line mx-auto mt-6 max-w-xs" />
        </div>

        {/* Sponsor Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {sponsors.map((sponsor, index) => (
            <div
              key={sponsor.id}
              className={`group relative transition-all duration-700 ${
                isLoaded
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${index * 120}ms` }}
            >
              {/* Glow */}
              <div className="absolute inset-0 neon-card-glow opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              {/* Card */}
              <div className="relative h-40 border border-primary/30 bg-card/50 backdrop-blur-md flex items-center justify-center">
                <span className="font-display text-primary text-glow-blue text-xs tracking-[0.2em] uppercase">
                  {sponsor.name}
                </span>
              </div>

              {/* Corners */}
              <div className="absolute top-0 left-0 w-4 h-4 border-l-2 border-t-2 border-primary" />
              <div className="absolute top-0 right-0 w-4 h-4 border-r-2 border-t-2 border-secondary" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-l-2 border-b-2 border-secondary" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-r-2 border-b-2 border-primary" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SponsorsSection;
